import { FormInstance, Row } from "antd";
import { OptionSelect } from "./OptionSelect";
import { useState } from "react";
import { Settings } from "./Settings";
import { ScheduleEmailOptions } from "../..";

type RecurrentEmailSettingsProps = {
  form: FormInstance;
  initialData: any;
  options?: ScheduleEmailOptions;
};

export const RecurrentSettings = ({ form, initialData, options }: RecurrentEmailSettingsProps) => {
  const [selectedOption, setSelectedOption] = useState<number>(initialData ? initialData.frequencyType : 1);

  return (
    <Row className="mt-4 d-block">
      <OptionSelect form={form} selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
      {selectedOption !== 1 && <Settings form={form} options={options} />}
    </Row>
  );
};
